<template>
  <div class="pdt-20px">
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('secondStepUtilisateur.title')}}
            </p>
          </header>
          <div class="card-content">
            <p class="mgb-40px">
              {{ $t('secondStepUtilisateur.sousTitle')}}
            </p>
            <div class="columns checkbox-custom-disabled" v-if="societesAgence">
              <div v-for="(societe, index) in societesAgence" :key="index"
                   class="column is-2 has-text-link">
                <b-checkbox v-model="societe.selected" :disabled="societe.disabled"
                            :type="isDisabled(societe.disabled)"
                            @input="switchAllValueSelected(societe);"
                >
                  <div class="columns is-vcentered">
                  <span class="is-link has-text-weight-bold is-size-6 column">
                    {{ societe.libelle }}
                  </span>
                  </div>
                </b-checkbox>
                <div class="mgt-5px mgl-20px checkbox-custom-children
                has-text-default">
                  <div v-for="(agence, index) in societe.agences" :key="index">
                    <b-checkbox v-model="agence.selected" :disabled="agence.disabled"
                                class="mgt-10px" :type="isDisabled(agence.disabled)"
                                @input="activeSociete(societe); updateinfoUser()"
                    >
                      {{ agence.libelle }}
                    </b-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    infoUser: Object,
    societesAgence: Array,
  },
  methods: {
    isDisabled(disabled) {
      if (disabled) return 'is-default';
      return 'is-primary';
    },
    updateinfoUser() {
      this.societesAgence.forEach((societe) => {
        societe.agences.forEach((agence) => {
          const index = this.infoUser.agencesId.indexOf(agence.id);
          if (index > -1 && !agence.selected) this.infoUser.agencesId.splice(index, 1);
          else if (index === -1 && agence.selected) this.infoUser.agencesId.push(agence.id);
        });
      });
    },
    switchAllValueSelected(societe) {
      societe.agences.forEach((agence) => {
        agence.selected = societe.selected;
      });
      this.updateinfoUser();
    },
    activeSociete(societe) {
      societe.selected = false;
      const isActive = societe.agences.find(agence => agence.selected);
      if (isActive) societe.selected = true;
    },
  },
};
</script>

<style scoped>

</style>
